<template>
  <div class="input-action">
    <el-input
      v-if="data.mask"
      v-mask="data.mask"
      :value="value"
      :placeholder="data.placeholder"
      :class="{
        [data.class]: !![data.class],
        'is-large': isLarge
      }"
      @input="handleInput"
      @keyup.enter.native="validate"
      @focus="isFocused = true"
      @blur="isFocused = false" />

    <el-input
      v-else
      v-model="value"
      :placeholder="data.placeholder"
      :class="data.class"
      @keyup.enter.native="validate"
      @focus="isFocused = true"
      @blur="isFocused = false" />

    <ButtonAction
      class="mt-3"
      :data="{ label: data.label }"
      :is-disabled="isValidationDisabled"
      :is-large="isLarge"
      :is-focused="isFocused"
      @validate="validate" />
  </div>
</template>

<script>
import ButtonAction from "@/components/chatbot/Bubbles/actions/ButtonAction"
import { mask } from "vue-the-mask"

export default {
  name: "InputAction",
  components: { ButtonAction },
  directives: { mask },
  props: {
    data: {
      type: Object,
      required: true
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: null,
      isFocused: false
    }
  },
  computed: {
    isValidationDisabled() {
      if (!this.value) {
        return true
      }

      if (this.data.validator && !this.data.validator(this.value)) {
        return true
      }

      return false
    }
  },
  created() {
    this.value = this.data.value || null
  },
  methods: {
    handleInput(value) {
      this.value = this.data.transform ? this.data.transform(value) : value
    },
    validate() {
      this.$emit("validate", this.value)
    }
  }
}
</script>

<style lang="scss">
.input-action {
  .el-input .el-input__inner {
    border-radius: 40px;
    border-width: 2px;
    font-weight: 500;
    padding: 0 16px;
  }
}
</style>

<style lang="scss" scoped>
.input-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;

  .el-input.is-large {
    line-height: 48px;
    height: 48px;
    padding: 0 24px;
  }
}
</style>
